import React from "react"
import { cn } from "./cn"

// Title (+ optional subtitle and action) shown at the top of the list/detail
// pages (Patients, Prescriptions, Transactions, PatientDetail). Owns the gap
// below the header so the spacing into page content is consistent everywhere.
export default function PageHeader({ title, subtitle, action, className = "" }) {
  return (
    <div className={cn("flex justify-between items-start gap-4 mb-4", className)}>
      <div>
        <h2 className="text-3xl font-bold tracking-tight text-gray-900">{title}</h2>
        {subtitle && <p className="text-gray-500 mt-1 mb-0">{subtitle}</p>}
      </div>
      {action}
    </div>
  )
}
